var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonclass,attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',[_c('p',{staticClass:"buttontext"},[_vm._v(_vm._s(_vm.toplabel))])])])}
var staticRenderFns = []

export { render, staticRenderFns }